import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'slugify',
  standalone: false,
})
export class SlugifyPipe implements PipeTransform {
  public transform(value: string | null | undefined): string | null | undefined {
    return value?.trim().toLowerCase().replace(/\s+/g, '-');
  }
}
